import { expected } from '@aloft/toolkit-shared';

import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { PageID } from '../../../components/ReferenceBar/HelpDrawer/types.js';

const pathEndingToPageID: Record<string, PageID> = {
  'paired-cost/properties': 'properties',
  'paired-cost/market-conditions': 'market-conditions',
  'paired-cost/cost-details': 'replacement-cost',
  'paired-cost/cost-approach': 'depreciation-and-site',
  'paired-cost/summary': 'summary',
  'paired-cost/adjustments-summary': 'adjustments-summary',
  'paired-cost/commentary-summary': 'commentary-summary',
  'paired-cost/cost-appr-summary': 'cost-appr-summary',
  studies: 'paired-sales-library',
  'paired-cost/analysis': 'analysis',
  'paired-cost/adjustments': 'adjustments',
  'paired-cost/commentary': 'commentary',
  'paired-cost/craftsman-cost-approach': 'craftsman-cost-approach',
  qc: 'qc',
};

/** Gets the Contentful document page ID for the current route. */
export function useHelpDrawerPageID(): { pageID: PageID | null } {
  const { pathname } = useLocation();

  const pageID = useMemo(() => {
    for (const pathEnding in pathEndingToPageID) {
      if (pathname.endsWith(pathEnding)) {
        return expected(pathEndingToPageID[pathEnding]);
      }
    }

    // HACK: The search and adjust parts of paired sales are in the same route.
    // Instead of adding a subrouter, we check if we're in any part of the paired
    // sales process. Unfortunately, this means that the help drawer will only show
    // one document for the entire paired sales flow.
    if (pathname.includes('paired-sales')) {
      return 'paired-sales-search-and-adjust';
    }

    return null;
  }, [pathname]);

  return { pageID };
}
